import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/NearshopLogoNew.png";

const Home = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4 sm:p-8">
      <div className="bg-white shadow-md rounded-lg p-6 sm:p-8 md:p-10 max-w-md md:max-w-2xl w-full text-center">
        <img
          src={logo}
          alt="NearShop Logo"
          className="mx-auto mb-6 w-32 sm:w-40 md:w-48"
        />
        <h1 className="text-3xl font-bold mb-4 text-gray-800">
          Welcome to NearShop
        </h1>
        <p className="text-gray-700 mb-4">
          <Link
            to="/about"
            className="text-orange-500 underline block text-3xl mb-2"
          >
            About Us
          </Link>
          <Link
            to="/privacy"
            className="text-orange-500 underline block text-3xl mb-2"
          >
            Privacy Policy
          </Link>
          <Link
            to="/terms"
            className="text-orange-500 underline block text-3xl mb-2"
          >
            Terms and Conditions
          </Link>
          <Link
            to="/hopcoms"
            className="text-orange-500 underline block text-3xl"
          >
            Hopcoms
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Home;
